import React, { useMemo } from 'react';
import classNames from 'classnames';
import noop from '../../../../utils/noop';
import Heading from '../../heading';
import Paragraph from '../../paragraph';
import TextSkeleton from '../../skeletons/text-skeleton';
import ActionButton from '../../action-button';
import PlanPricing from '../plan-pricing';
import PlanDiscount from '../plan-discount';
import ButtonSkeleton from '../../skeletons/button-skeleton';

const defaultCaptions = {};

const Plan = ({
  captions = defaultCaptions,
  highlighted = false,
  limited = false,
  disabled = false,
  isLoading = false,
  onPlanSelect = noop,
  isCompact = false,
  type,
  withIntroPriceDiscounts = false,
}) => {
  const { name, description, cta, pricing, priceDescription, introDiscountLabel } = captions;
  const classes = classNames('ws-ui-plan', {
    'ws-ui-plan--highlighted': highlighted,
    'ws-ui-plan--limited': limited,
    'ws-ui-plan--disabled': disabled,
    'ws-ui-plan--compact': isCompact,
    'ws-ui-plan--with-discount': withIntroPriceDiscounts,
  });
  const oldPrice = pricing?.oldPrice;

  const priceButtonAppearance = useMemo(() => {
    if (highlighted && limited) {
      return 'gradient';
    }

    if (highlighted) {
      return 'accent';
    }

    return 'default';
  }, [highlighted, limited]);

  const priceBtnClass = classNames('ws-ui-plan__price-button', {
    'ws-ui-plan__price-button--loading': isLoading,
  });

  const handlePlanSelect = () => {
    onPlanSelect(type);
  };

  return (
    <div className={classes}>
      {withIntroPriceDiscounts && (
        <div className="ws-ui-plan__discount-wrapper">
          <PlanDiscount label={introDiscountLabel} />
        </div>
      )}
      <div className="ws-ui-plan__head">
        <Heading type="heading-3">
          {isLoading ? (
            <TextSkeleton width="68px" centered />
          ) : (
            <span className="ws-ui-plan__name">{name}</span>
          )}
        </Heading>
        {(isLoading || description) && (
          <div className="ws-ui-plan__description">
            <Paragraph appearance="medium-emphasis">
              {isLoading ? <TextSkeleton width="140px" centered /> : description}
            </Paragraph>
          </div>
        )}
      </div>
      <div className="ws-ui-plan__body">
        {withIntroPriceDiscounts && <div className="ws-ui-plan__old-price">{oldPrice}</div>}
        <PlanPricing {...pricing} isLoading={isLoading} />
        {!isLoading && typeof priceDescription === 'string' && (
          <Paragraph appearance="medium-emphasis" size="small">
            {!isCompact && !priceDescription.trim() ? <>&nbsp;</> : priceDescription}
          </Paragraph>
        )}
      </div>
      <div className={priceBtnClass}>
        {isLoading ? (
          <ButtonSkeleton />
        ) : (
          <ActionButton
            fullWidth={!isCompact}
            label={cta}
            appearance={priceButtonAppearance}
            disabled={disabled}
            format={highlighted ? 'solid' : 'outline'}
            isClipped={false}
            onClick={handlePlanSelect}
          />
        )}
      </div>
    </div>
  );
};

export default Plan;
